export default __webpack_public_path__ + "static/media/Frame_184.27930b15.jpg";